import React, { useEffect, useState } from 'react';
import '../styles/Panduan.css';

const Panduan = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        const section = document.getElementById('panduan');
        if (section) observer.observe(section);

        return () => {
            if (section) observer.unobserve(section);
        };
    }, []);

    return (
        <section
            id="panduan"
            className={`panduan-pelaporan ${isVisible ? 'fadeIn' : ''}`}
        >
            <h2>Panduan Pelaporan</h2>
            <div className="steps">
                <div className="step">
                    <h3>01</h3>
                    <p>Klik Tombol “Buat Laporan”</p>
                </div>
                <div className="step">
                    <h3>02</h3>
                    <p>Isi formulir yang tersedia</p>
                </div>
                <div className="step">
                    <h3>03</h3>
                    <p>Tunggu respons dari tim pengelola</p>
                </div>
            </div>
        </section>
    );
};

export default Panduan;
